export default __webpack_public_path__ + "static/media/thumbnail.ea86382c.png";